var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManageAccounts({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#7292F7",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_246_796)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.67 14.02C10.45 14.01 10.23 14 10 14C7.58 14 5.32 14.67 3.39 15.82C2.51 16.34 2 17.32 2 18.35V20C2 20.55 2.45 21 3 21H11.26C10.47 19.87 10 18.49 10 17C10 15.93 10.25 14.93 10.67 14.02Z",
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 13C12.2091 13 14 11.2091 14 9C14 6.79086 12.2091 5 10 5C7.79086 5 6 6.79086 6 9C6 11.2091 7.79086 13 10 13Z",
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7499 17C20.7499 16.78 20.7199 16.58 20.6899 16.37L21.5299 15.64C21.7099 15.48 21.7499 15.22 21.6299 15.01L21.0399 13.99C20.9199 13.78 20.6699 13.69 20.4499 13.77L19.3899 14.13C19.0699 13.86 18.7099 13.65 18.3099 13.5L18.0899 12.41C18.0399 12.18 17.8399 12.01 17.5999 12.01H16.4199C16.1799 12.01 15.9799 12.18 15.9299 12.41L15.7099 13.5C15.3099 13.65 14.9499 13.86 14.6299 14.13L13.5699 13.77C13.3399 13.69 13.0999 13.79 12.9799 13.99L12.3899 15.01C12.2699 15.22 12.3099 15.48 12.4899 15.64L13.3299 16.37C13.2999 16.58 13.2699 16.78 13.2699 17C13.2699 17.22 13.2999 17.42 13.3299 17.63L12.4899 18.36C12.3099 18.52 12.2699 18.78 12.3899 18.99L12.9799 20.01C13.0999 20.22 13.3499 20.31 13.5699 20.23L14.6299 19.87C14.9499 20.14 15.3099 20.35 15.7099 20.5L15.9299 21.59C15.9799 21.82 16.1799 21.99 16.4199 21.99H17.5999C17.8399 21.99 18.0399 21.82 18.0899 21.59L18.3099 20.5C18.7099 20.35 19.0699 20.14 19.3899 19.87L20.4499 20.23C20.6799 20.31 20.9199 20.21 21.0399 20.01L21.6299 18.99C21.7499 18.78 21.7099 18.52 21.5299 18.36L20.6899 17.63C20.7199 17.42 20.7499 17.22 20.7499 17ZM16.9999 19C15.8999 19 14.9999 18.1 14.9999 17C14.9999 15.9 15.8999 15 16.9999 15C18.0999 15 18.9999 15.9 18.9999 17C18.9999 18.1 18.0999 19 16.9999 19Z",
    fill: "inherit"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_246_796"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageAccounts);
export default __webpack_public_path__ + "static/media/manage_accounts.636619e9002f2a1ea85aac1a35e4a16a.svg";
export { ForwardRef as ReactComponent };